import { Box } from '@mui/material';
import styled from 'styled-components';

export const CustomBox = styled(Box)`
  ${(props) => (!props.read ? `background-color: rgba(238, 126, 91, .3);` : '')}
  padding: 1rem;
  border: 1px solid rgba(238, 126, 91, 0.6);
  border-radius: 10px;
  margin-bottom: 4px;
  width: 100%;
  ${(props) => (props.clickable ? `cursor: pointer;` : '')}
`;
